
@switch (indicatorType) {
  @case ('circle') {
    <mat-progress-spinner mode="indeterminate" diameter="30" strokeWidth="2"></mat-progress-spinner>
  }
  @case ('bar') {
    <mat-progress-bar mode="indeterminate" style="width: 60%"></mat-progress-bar>
  }
  @default {
    <mat-progress-spinner mode="indeterminate" diameter="30" strokeWidth="2"></mat-progress-spinner>
  }
}
